/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._1mT5xd5HSx%7Bposition%3Astatic%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");




import { SpacingContext } from '../internal/components/menu-context';
import { SELECTION_STYLE_CONTEXT_DO_NOT_USE } from '../internal/components/selection-style-context-do-not-use';
import type { MenuGroupProps } from '../types';
const baseStyles = null;

/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
const MenuGroup: (props: MenuGroupProps) => JSX.Element = ({
  isLoading,
  maxWidth,
  minWidth,
  minHeight,
  maxHeight,
  testId,
  role,
  spacing = 'cozy',
  menuLabel,
  // Although this isn't defined on props it is available because we've used
  // Spread props below and on the jsx element. To forcibly block usage I've
  // picked it out and supressed the expected type error.
  // @ts-expect-error
  className: UNSAFE_className,
  ...rest
}: MenuGroupProps) => <SpacingContext.Provider value={spacing}>
		<SELECTION_STYLE_CONTEXT_DO_NOT_USE.Provider value="border">
			<div aria-busy={isLoading} style={{
      minWidth,
      maxWidth,
      minHeight,
      maxHeight
    }} data-testid={testId} role={role}
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className={ax(["_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _1mT5xd5HSx _0aFT5vbt8w", UNSAFE_className])} aria-label={menuLabel}
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    {...rest} />
		</SELECTION_STYLE_CONTEXT_DO_NOT_USE.Provider>
	</SpacingContext.Provider>;
export default MenuGroup;